//lazysizes
import "lazysizes";
import "./accordion";
import "./book-responsive-tabs";
import "./dropdown-jump-to";
import "./book-preview";
import "./journal-details";
import "./nav";
import "./post-related-books";
import "./predictive-search";
import "./product-page";
import "./purify-txt";
import "./related-books";
import "./retailers-list";
import "./search-mobile-triggers";
import "./secondary-nav";
import "./sticky-nav";
import "./promo-banner";
import "./share-this-tab-class";
import "./ajax-buy-buttons";
import "./embla-slider";
import "./subjects-dropdown";
import "./interior-image-carousel";
import "./loop-mask";
import "./supapress-filters";
